import React, { useContext, useEffect, useState } from "react";
import dynamic from "next/dynamic";
import Image from "next/image";
import Local from "../ImageLoader";
import { GetSimilarVillas } from "../api";
import Photos from "../Detail/Photos";

const ProductInfo = dynamic(() => import("../Detail/ProductInfo"), {
  ssr: false,
  loading: () => (
    <div className="w-full flex flex-col items-center justify-center py-4 lg:hidden">
      <Skeleton containerClassName="w-1/2" className="h-7" />
      <Skeleton containerClassName="w-1/4 mt-1" className="h-4" />
      <Skeleton containerClassName="w-1/4 mt-2" className="h-6" />
    </div>
  ),
});
const SidebarForm = dynamic(() => import("../Detail/SidebarForm"), {
  ssr: false,
});
const AvailabilityModal = dynamic(() => import("../Detail/AvailabilityModal"), {
  ssr: false,
});
const Right = dynamic(() => import("../Detail/Right"));
const ListVilla = dynamic(() => import("../ListVilla"), {
  ssr: false,
});
const WriteReview = dynamic(() => import("../WriteReview"), {
  ssr: false,
});

import "react-date-range/dist/styles.css"; // main css file
import "react-date-range/dist/theme/default.css"; // theme css file
import Skeleton from "react-loading-skeleton";
import { StoreContext } from "../../context/context";
import isMobile from "is-mobile";
import { useTranslation } from "../../context/TranslationContext";
import GavelLoginForm from "../GavelLoginForm";
import { getCookie } from "./ProductCategory";

const Detail = ({ ssr, isAppWebView, deviceType }) => {
  const { detailSimilarVillasTitle } = useTranslation();
  const isPhone = isMobile();
  const {
    backdrop,
    mobileBar,
    setMobileBar,
    sonDakikaDates,
    setSonDakikaDates,
  } = useContext(StoreContext);
  const [showAvailability, setShowAvailability] = useState(false);
  const [gavelLoginSuccess, setGavelLoginSuccess] = useState(false);

  //Son dakika fırsatındaki tarihleri rezervasyon formuna aktarır
  const SelectSonDakika = (start, end) => {
    if (!start || !end) {
      setSonDakikaDates(null);
      return;
    }
    setSonDakikaDates([
      {
        startDate: new Date(start + "T00:00:00"),
        endDate: new Date(end + "T00:00:00"),
        key: "selection",
        isShow: 0,
      },
    ]);
    // Mobil / uygulama: alttaki "Rezervasyon Yap" formuyla aynı paneli aç
    if (isPhone || isAppWebView) setMobileBar("reservationForm");
  };
  useEffect(() => {
    if (backdrop == false) setShowAvailability(false);
  }, [backdrop]);

  useEffect(() => {
    setGavelLoginSuccess(false);
    setSonDakikaDates(null);
    if (getCookie("user-link") == "1") {
      if (
        ("," + getCookie("ids") + ",").indexOf("," + ssr.result?.id + ",") > -1
      ) {
        setGavelLoginSuccess(true);
        ssr.result.gavel = 0;
      }
    }
  }, [ssr.result?.id]);

  useEffect(() => {
    setShowAvailability(mobileBar == "availabilityMobile");
  }, [mobileBar]);

  if (
    ssr.result.gavel == "1" &&
    !gavelLoginSuccess &&
    ssr.result.gavelDetailOption == "1"
  ) {
    return (
      <GavelLoginForm
        setGavelLoginSuccess={setGavelLoginSuccess}
        emlak={ssr.result.id}
      />
    );
  }
  return (
    <div className="lg:mt-1 bg-[#ECF2F4] lg:bg-white">
      {showAvailability ? (
        <AvailabilityModal
          showAvailability={showAvailability}
          setShowAvailability={setShowAvailability}
          id={ssr.result.id}
          baslik={ssr.result.baslik}
          kisi={ssr.result.kisi}
          isActive={ssr.result.aktif}
          gavel={ssr.result.gavel}
          start2={ssr.result.start2}
          isAppWebView={isAppWebView}
          deviceType={deviceType}
          paymentType={ssr.result.paymentType}
          defaultDates={sonDakikaDates}
        />
      ) : null}
      <ProductInfo
        data={ssr.result.photos}
        title={ssr.result.baslik}
        destination={ssr.result.destination}
        video={ssr.result.video}
        page={ssr.result}
        isAppWebView={isAppWebView}
      />

      <Photos data={ssr.result.photos} page={ssr.result} />
      <div className="relative lg:-mt-36 w-full z-10">
        {!isPhone && (
          <SidebarForm
            showAvailability={showAvailability}
            setShowAvailability={setShowAvailability}
            page={ssr.result}
            isAppWebView={isAppWebView}
            deviceType={deviceType}
            defaultState={sonDakikaDates}
          />
        )}
        <Right
          showAvailability={showAvailability}
          setShowAvailability={setShowAvailability}
          page={ssr.result}
          isPhone={isPhone}
          deviceType={deviceType}
          onSelectSonDakika={SelectSonDakika}
        />
      </div>
      <ListVilla
        baslik={detailSimilarVillasTitle}
        className="bg-brand-gray-7 lg:bg-transparent"
        ItemClassName="bg-white lg:bg-brand-gray-7 "
        fetch={GetSimilarVillas(ssr.result.id, ssr.result.emlak_bolgesi)}
        IconUrl={
          <Image
            src={"/icons/trophy.svg"}
            alt="trophy"
            width={39}
            height={29}
            loader={Local}
          />
        }
      />
      {ssr.result.ReviewReservation && <WriteReview ssr={ssr.result} />}
    </div>
  );
};

export default Detail;
